import {GLOBAL_SEARCH_PAGE_NAME} from './modules/global-search/global-search.component';
import {guardPaperOrPersonalOrInternalConsignment, LazyModuleOutletComponent,} from '|shared';
import {EsslApplicationModule, EsslApplicationRole} from '|api/commons';
import {IczRoutes, NotFoundPageComponent} from '@icz/angular-application-core';
import {
  ActionRoute,
  DocumentsDashboardRoute,
  DocumentsRoute,
  DynamicRoutePlaceholder,
  guardActiveEsslApplicationModules,
  guardEsslApplicationRole
} from '|ui-essl-core';

export const ROUTES: IczRoutes = [
  {
    path: '',
    title: 'Dokumenty',
    component: LazyModuleOutletComponent,
    children: [
      {
        path: `${DocumentsRoute.IN_PROGRESS}`,
        title: 'Vyřizované',
        loadChildren: () => import('./modules/in-progress-documents/in-progress-documents.routes').then(m => m.ROUTES),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.EXPIRING,
        title: 'Blízký termín',
        loadChildren: () =>import('./modules/expiring-documents/expiring-documents.routes').then(m => m.ROUTES),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsDashboardRoute.DASHBOARD,
        title: 'Nástěnka',
        loadChildren: () => import('./modules/documents-dashboard/documents-dashboard.routes'),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.NOTIFICATIONS,
        title: 'Upozornění',
        loadChildren: () => import('./modules/notifications-overview/notifications-overview.routes'),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.ADVANCED_SEARCH,
        title: 'Pokročilé vyhledávání',
        loadChildren: () => import('./modules/global-search-criteria/global-search-criteria.routes'),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.SEARCH,
        title: GLOBAL_SEARCH_PAGE_NAME,
        loadChildren: () => import('./modules/global-search/global-search.routes'),
        data: {isRootLevelRoute: true, usesAlias: true},
      },
      {
        path: DocumentsRoute.SETTLED,
        title: 'Ukončené',
        loadChildren: () => import('./modules/settled-documents/settled-documents.routes').then(m => m.ROUTES),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.TASKS,
        title: 'Úkolovník',
        loadChildren: () => import('./modules/document-tasks/document-tasks.routes').then(m => m.ROUTES),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.SIGNATURE_BOOK,
        title: 'Podpisová kniha',
        loadChildren: () => import('./modules/essl-component-tasks/essl-component-tasks.routes').then(m => m.ROUTES),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.REGISTRY_OFFICE_TRANSFERS,
        title: 'Spisovna',
        loadChildren: () => import('./modules/officer-transfers/officer-transfers.routes').then(m => m.ROUTES),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: `${DocumentsRoute.DOCUMENT}/${DynamicRoutePlaceholder.UUID}`,
        title: 'Detail dokumentu',
        loadChildren: () => import('./modules/document-detail/document-detail.routes').then(m => m.ROUTES),
      },
      {
        path: `${DocumentsRoute.MANUALLY_SHARED}`,
        title: 'Nasdíleno',
        loadChildren: () => import('./modules/manual-shared-documents/manual-shared-documents.routes'),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: `${DocumentsRoute.FILE}/${DynamicRoutePlaceholder.UUID}`,
        title: 'Detail spisu',
        loadChildren: () => import('./modules/file-detail/file-detail.routes').then(m => m.ROUTES),
      },
      {
        path: `${DocumentsRoute.STORAGE_UNIT}/${DynamicRoutePlaceholder.UUID}`,
        title: 'Detail ukládací jednotky',
        loadChildren: () => import('./modules/storage-unit-detail/storage-unit-detail.routes'),
      },
      {
        path: `${DynamicRoutePlaceholder.UUID}/${DocumentsRoute.FILE}`,
        title: 'Založení spisu',
        loadChildren: () => import('./modules/new-file/new-file.routes'),
      },
      {
        path: `${DocumentsRoute.EMPTY_FILE}`,
        title: 'Založení prázdného spisu',
        loadChildren: () => import('./modules/new-file/new-file.routes'),
      },
      {
        path: `${DynamicRoutePlaceholder.UUID}/${DocumentsRoute.DUPLICATE}`,
        title: 'Založení duplikátu dokumentu',
        loadChildren: () => import('./modules/document-duplicate/document-duplicate.routes'),
      },
      {
        path: `${DynamicRoutePlaceholder.UUID}/${DocumentsRoute.REGISTER_CONTENT_OFFICER}`,
        title: 'Zaevidování obsahu',
        loadChildren: () => import('./modules/document-register-content/components/document-register-content-by-officer/document-register-content-by-officer.routes'),
      },
      {
        path: `${DynamicRoutePlaceholder.UUID}/${DocumentsRoute.REGISTER_CONTENT_FILING_OFFICE}`,
        title: 'Zaevidování obsahu',
        canActivateChild: [guardPaperOrPersonalOrInternalConsignment()],
        loadChildren: () => import('./modules/document-register-content/components/document-register-content-by-filing-office/document-register-content-by-filing-office.routes'),
      },
      {
        path: `${DynamicRoutePlaceholder.UUID}/${DocumentsRoute.NEW_RESPONSE_DOCUMENT}`,
        title: 'Založení odpovědi (vyřizující dokument)',
        loadChildren: () => import('./modules/response-document/response-document.routes'),
      },
      {
        path: `${DocumentsRoute.CASE_FILES}`,
        title: 'Typové spisy',
        loadChildren: () => import('./modules/case-files/case-files.routes'),
        data: {canBeFavourite: true, isRootLevelRoute: true},
        canActivate: [guardActiveEsslApplicationModules([EsslApplicationModule.CASE_FILE])]
      },
      {
        path: `${DocumentsRoute.CASE_FILE}/${ActionRoute.NEW}`,
        title: 'Založení typového spisu',
        canActivate: [guardEsslApplicationRole([EsslApplicationRole.CF_USAGE])],
        loadChildren: () => import('./modules/case-file/case-file.routes'),
      },
      {
        path: `${DocumentsRoute.CASE_FILE}/${DynamicRoutePlaceholder.UUID}`,
        title: 'Detail typového spisu',
        loadChildren: () => import('./modules/case-file-detail/case-file-detail.routes'),
      },
      {
        path: `${DocumentsRoute.FILE}/${DynamicRoutePlaceholder.ID}/${DocumentsRoute.OWN_DOCUMENT_TO_FILE}`,
        title: 'Založení vlastního dokumentu do spisu',
        loadChildren: () => import('./modules/own-document/own-document.routes'),
      },
      {
        path: `${DocumentsRoute.FILE}/${DynamicRoutePlaceholder.ID}/${DocumentsRoute.RECEIVED_DOCUMENT_TO_FILE}`,
        title: 'Založení doručeného dokumentu do spisu',
        loadChildren: () => import('./modules/create-received-document-by-referent/create-received-document-by-referent.routes'),
      },
      {
        path: `${DocumentsRoute.FILE}/${DynamicRoutePlaceholder.ID}/${DocumentsRoute.FILE_LOSS_STATEMENT}`,
        title: 'Založení protokolu o ztrátě',
        loadChildren: () => import('./modules/file-loss-statement/file-loss-statement.routes'),
      },
      {
        path: ActionRoute.NEW,
        title: 'Založení vlastního dokumentu',
        loadChildren: () => import('./modules/own-document/own-document.routes'),
        data: {canBeFavourite: true},
      },
      {
        path: DocumentsRoute.RECEIVED,
        title: 'Založení doručeného dokumentu',
        loadChildren: () => import('./modules/create-received-document-by-referent/create-received-document-by-referent.routes'),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.EXTERNAL_APPLICATION_DOCUMENTS,
        title: 'Externí aplikace',
        loadChildren: () => import('./modules/documents-external-application/documents-external-application.routes'),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: DocumentsRoute.CROSS_REFERENCES_OFFICER,
        title: 'Křížové odkazy',
        loadChildren: () =>import('./modules/cross-references/cross-references-table.routes').then(m => m.ROUTES),
        data: {canBeFavourite: true, isRootLevelRoute: true},
      },
      {
        path: '**',
        component: NotFoundPageComponent,
        data: {skipHistoryBit: true}
      },
    ],
  },
];

export default ROUTES;
